// @hq-org/kit-wasm: the kit's sync engine (Rust → wasm) with its TS host. One call gives a live, offline-capable store:
//
//   const kit = await createKit({ origin, token, storage: indexedDb(`hq-kit:${instance}:${person}`) })
//   const sub = kit.subscribe({ kind: "hq.tasks.Task", where: { space: "spc_x" }, order: [{ field: "rank" }] }, render)
//   kit.update("hq.tasks.Task", id, { status: "done" })   // optimistic; `.done` resolves landed | refused
import init, { initSync, Kit as WasmKit } from "../pkg/kit_wasm.js";
import { engineOptions, host, type Kit, type KitOptions, loader, type WasmSource } from "./host";

export { engineOptions, host, KitError, loader } from "./host";
export { Driver, IoError, entropy } from "./driver";
export type { Acted, Kit, KitOptions, Status, Subscription, Watching, Written } from "./host";
export { indexedDb, memory } from "./idb";
export type * from "./types";

/** Load the wasm once (host.ts loader). */
export const loadKit = loader(init, initSync);

/** A kit over the wasm core. */
export async function createKit(o: KitOptions & { wasm?: WasmSource }): Promise<Kit> {
	await loadKit(o.wasm);
	return host(new WasmKit(engineOptions(o)), o);
}
